<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<div class="card">
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
            <button pButton pRipple label="{{translations.lbl_new}} {{translations.lbl_record}}" icon="pi pi-plus"
                class="p-button-success p-mr-2" (click)="openNew()"></button>
        </ng-template>
    </p-toolbar>

    <p-table #dt [value]="listZonesCoord" [rows]="20" [paginator]="true"
        [globalFilterFields]="['coord.storeId','coord.name','coord.begDate','coord1','secre1','treas1', 'mate1', 'address']"
        [(selection)]="selectedProducts" [rowHover]="true" dataKey="storeId" styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{translations.lbl_list}} {{translations.lbl_zonal_coordinations}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="coord.storeId">{{translations.lbl_id}} {{translations.lbl_zone}} <p-sortIcon
                        field="coord.storeId"></p-sortIcon></th>
                <th pSortableColumn="coord.name">{{translations.lbl_name}} <p-sortIcon field="coord.name"></p-sortIcon>
                </th>
                <th pSortableColumn="coord.begDate">{{translations.lbl_starting_date}} <p-sortIcon
                        field="coord.begDate"></p-sortIcon></th>
                <th pSortableColumn="coord1">{{translations.lbl_coordinator}} <p-sortIcon field="coord1"></p-sortIcon>
                </th>
                <th pSortableColumn="secre1">{{translations.lbl_secretary}} <p-sortIcon field="secre1"></p-sortIcon>
                </th>
                <th pSortableColumn="treas1">{{translations.lbl_treasurer}} <p-sortIcon field="treas1"></p-sortIcon>
                </th>
                <th pSortableColumn="mate1">{{translations.lbl_material_man}}<p-sortIcon field="mate1"></p-sortIcon>
                </th>
                <th pSortableColumn="address"> {{translations.lbl_main_address}} <p-sortIcon
                        field="address"></p-sortIcon></th>
                <!-- <th pSortableColumn="inventoryStatus">{{translations.lbl_short_Name }} <p-sortIcon field="inventoryStatus"></p-sortIcon></th> -->
                <th> {{translations.lbl_actions}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-zone>
            <tr>
                <td>{{zone.coord.storeId }}</td>
                <td>{{zone.coord.name}}</td>
                <td>{{formatDate(zone.coord)}}</td>
                <td>{{zone.coordName != null ? zone.coordName : ''}}</td>
                <td>{{zone.secreName != null ? zone.secreName : ''}}</td>
                <td>{{zone.treasName != null ? zone.treasName : ''}}</td>
                <td>{{zone.mateName != null ? zone.mateName : ''}}</td>
                <td>{{formatAddress(zone.storeAddress)}}</td>
                <!-- <td>{{zone.coordName}}</td> -->
                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        (click)="editCoord(zone)"></button>
                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-error p-mr-2"
                        (click)="selectionCoordinationCatalog(zone)"></button>
                    <!-- [disabled]="globalUserPreferences.preferences.levelId != 'I' && globalUserPreferences.preferences.storeId != zone.coord.storeId" -->
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{translations.lbl_there_are}} {{listZonesCoord ? listZonesCoord.length : 0
                }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>

<!-- <p-dialog [(visible)]="zoneDialog" [style]="{width: '750px'}" header="Zona" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        img [src]="'assets/showcase/images/demo/product/' + product.image" [alt]="product.image" class="product-image" *ngIf="product.image"
        <div class="p-field">
            <label for="name">Zona </label>
            <input type="text" pInputText id="name" [(ngModel)]="zoneCoordModel.name" required autofocus />
            <small class="p-error" *ngIf="submitted && !zoneCoordModel.name">Zona es requerido.</small>
        </div>
        <div class="p-field">
            <label for="name">Nombre Corto: *</label>
            <input type="text" pInputText id="name" [(ngModel)]="zoneCoordModel.name" required autofocus />
            <small class="p-error" *ngIf="submitted && !zoneCoordModel.name">Nombre Corto es Requerido.</small>
        </div>
        <div class="p-field">
            <label for="begDate">Fecha Inicio: *</label>
            <p-calendar id="begDate" [(ngModel)]="zoneCoordModel.begDate" required autofocus dateFormat="yymmdd"></p-calendar>
            <small class="p-error" *ngIf="submitted && !zoneCoordModel.begDate">Zona es requerido.</small>
        </div>

        
    </ng-template>
    
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button>
    </ng-template>
</p-dialog> -->

<!-- <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog> -->